module.exports = __webpack_public_path__ + "img/loading-spin.8a6d3ff0.svg";